import { CheckCircle2, Loader2, Paperclip, AlertCircle } from 'lucide-react';
import type { PendingReply } from '../../lib/pendingReplies';

export function PendingReplyCard({ reply, canRestore, onRestore }: {
  reply: PendingReply; canRestore: boolean; onRestore: () => void;
}) {
  return (
    <div className="rounded-2xl bg-accent-deep/10 border border-accent-primary/20 p-5" data-pending-reply={reply.state}>
      <div className="flex items-center gap-2 text-sm" role="status" aria-live="polite">
        {reply.state === 'sending' ? <Loader2 className="w-4 h-4 animate-spin text-accent-primary" />
          : reply.state === 'failed' ? <AlertCircle className="w-4 h-4 text-danger" />
            : <CheckCircle2 className="w-4 h-4 text-success" />}
        <span className="font-medium text-text-primary">{reply.state === 'sending' ? 'Wysyłanie…' : reply.state === 'failed' ? 'Nie potwierdzono wysyłki' : 'Wysłano'}</span>
      </div>
      <p className="mt-2 text-xs text-text-secondary break-words">Do: {reply.draft.to}</p>
      <div className="mt-4 whitespace-pre-wrap break-words text-sm text-text-primary">{reply.bodyText}</div>
      {reply.filenames.map((name, index) => <div key={index} className="flex items-center gap-1.5 mt-2 text-xs text-text-secondary"><Paperclip className="w-3 h-3 shrink-0" /><span className="break-all">{name}</span></div>)}
      {reply.state === 'failed' && <div className="mt-3 text-sm text-danger">
        <p>{reply.error || 'Sprawdź błąd wysyłki przed ponowną próbą.'}</p>
        <button type="button" className="btn-ghost mt-2" disabled={!canRestore} onClick={onRestore}>Przywróć treść do edytora</button>
      </div>}
    </div>
  );
}
